// import React from 'react';
import ksk from '../../assets/images/kopi-susu-keluarga.png';
import americano from '../../assets/images/americano-series.png';
import bento from '../../assets/images/paket-bento.png';
import chicken from '../../assets/images/chrispy-chicken-korean-buldak.png';
import image_alert_icon from "../../assets/images/alert-icon.png";

function SectionMenu({ targetRef }) {

    const handleScroll = () => {
        targetRef.current?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <div className="section-menu md:px-[50px] lg:px-[100px] bg-[#F1F8FF]">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="flex items-center justify-start md:justify-end px-5">
                    <div className="flex flex-col">
                        <div>
                            <div className="flex items-center md:items-baseline">
                                <div>
                                    <img src={image_alert_icon} className="w-[40px] md:w-[40px] lg:w-[50px] xl:w-[82px] mr-5" alt="FamilyMart Indonesia" />
                                </div>
                                <div>
                                    <h2 className="text-sky-500 hidden md:flex md:text-3xl lg:text-5xl xl:text-7xl font-extrabold text-end">Flavor<br /> Alert! </h2>
                                    <h2 className="text-sky-500 flex md:hidden text-2xl md:text-3xl lg:text-5xl xl:text-7xl font-extrabold text-end">Flavor Alert! </h2>
                                </div>
                            </div>
                        </div>
                        <div className='hidden md:flex justify-end'>
                            <button onClick={handleScroll}><h4 className="text-sky-500 md:text-xl lg:text-2xl xl:text-4xl font-extrabold mt-[50px]"><u>Come Try Our <br /> Newest Treat!</u></h4></button>
                        </div>
                    </div>
                </div>
                <div className="col-span-2">
                    <div className='border-dashed border-4 border-[#F4C790] md:px-5 lg:px-5 xl:px-10 mx-[10px] md:mx-[50px]'>
                        <div className="grid grid-cols-2 gap-4">
                            <div className="place-items-center px-2 lg:px-2">
                                <img src={ksk} className="w-[100px] md:w-[200px] lg:w-[120px] xl:w-[200px]" alt="FamilyMart Indonesia" />
                                <h3 className="text-sky-500 text-xl md:text-xl lg:text-2xl xl:text-4xl font-extrabold text-center">Kopi Susu Keluarga</h3>
                            </div>
                            <div className="place-items-center px-2 lg:px-2">
                                <img src={americano} className="w-[100px] md:w-[200px] lg:w-[120px] xl:w-[200px]" alt="FamilyMart Indonesia" />
                                <h3 className="text-sky-500 text-xl md:text-xl lg:text-2xl xl:text-4xl font-extrabold text-center">Americano <br></br>Series</h3>
                            </div>
                            <div className="place-items-center px-2 lg:px-2">
                                <img src={bento} className="w-[100px] md:w-[200px] lg:w-[120px] xl:w-[200px]" alt="FamilyMart Indonesia" />
                                <h3 className="text-sky-500 text-xl md:text-xl lg:text-2xl xl:text-4xl font-extrabold text-center">Paket Bento</h3>
                            </div>
                            <div className="place-items-center px-2 lg:px-2">
                                <img src={chicken} className="w-[100px] md:w-[200px] lg:w-[120px] xl:w-[200px]" alt="FamilyMart Indonesia" />
                                <h3 className="text-sky-500 text-xl md:text-xl lg:text-2xl xl:text-4xl font-extrabold text-center">Crispy Chicken Korean Buldak</h3>
                            </div>
                        </div>
                    </div>

                    <div className='flex md:hidden justify-end px-5'>
                        <button onClick={handleScroll}><h4 className="text-sky-500 text-xl md:text-xl lg:text-2xl xl:text-4xl font-extrabold mt-[25px]"><u>Come Try Our Newest Treat!</u></h4></button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default SectionMenu;
